module.exports = require("./sv-FI.js");